import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import { Box, Text } from 'core/components';
import { DEFAULT_DATETIME_FORMAT_WITH_SECONDS, formatDateTime } from 'core/util/dateUtils';
import type $usersStore from 'app/stores/user/$users';

interface AckStateLabelProps {
  label?: string;
  isAcked: boolean;
  userId?: string | null;
  timestamp?: number | string;
}

/** An ack state, with who acked it and when once the acking user is known. */
const AckStateLabel = ({ label, isAcked, userId, timestamp }: AckStateLabelProps) => {
  const { $users } = useContext(MobXProviderContext) as { $users: typeof $usersStore };
  const userModel = userId ? $users.collection.modelById[userId] : undefined;

  // userModel should be present but we do not want to throw an error if not
  if (!userModel) {
    return <>{label || null}</>;
  }

  return (
    <Box>
      <Text as="div">{label}</Text>
      {isAcked && (
        <>
          <Text as="div" muted>
            by {userModel.get('user_full_name')}
          </Text>
          <Text as="div" muted>
            {formatDateTime(timestamp, DEFAULT_DATETIME_FORMAT_WITH_SECONDS)}
          </Text>
        </>
      )}
    </Box>
  );
};

export default observer(AckStateLabel);
